"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.poolABIContract = exports.oracleAdapterABIContract = exports.lpTokenOracleABIContract = exports.loanABIContract = exports.depositStakingABIContract = exports.depositsABIContract = void 0;
const algosdk_1 = require("algosdk");
const deposit_staking_json_1 = __importDefault(require("./deposit-staking.json"));
const deposits_json_1 = __importDefault(require("./deposits.json"));
const loan_json_1 = __importDefault(require("./loan.json"));
const lp_token_oracle_json_1 = __importDefault(require("./lp-token-oracle.json"));
const oracle_adapter_json_1 = __importDefault(require("./oracle-adapter.json"));
const pool_json_1 = __importDefault(require("./pool.json"));
exports.depositsABIContract = new algosdk_1.ABIContract(deposits_json_1.default);
exports.depositStakingABIContract = new algosdk_1.ABIContract(deposit_staking_json_1.default);
exports.loanABIContract = new algosdk_1.ABIContract(loan_json_1.default);
exports.lpTokenOracleABIContract = new algosdk_1.ABIContract(lp_token_oracle_json_1.default);
exports.oracleAdapterABIContract = new algosdk_1.ABIContract(oracle_adapter_json_1.default);
exports.poolABIContract = new algosdk_1.ABIContract(pool_json_1.default);
//# sourceMappingURL=index.js.map